<template>
  <a :id="id ? `c${id}` : undefined" v-bind="newAttrs">
    <slot />
  </a>
</template>

<script>
import TypolinkMixin from '@/js/mixins/typolink-mixin.js'

export default {
  name: 'BaseLink',
  mixins: [TypolinkMixin],
  props: {
    id: {
      type: String,
      default: undefined,
    },
  },
}
</script>
